module.exports.sidebarButtons = [
  {
    type: "paragraph-left",
    text: "Header 1",
    tag: "h1",
    displayText: "Header 1",
    styles: ["BOLD", "CUSTOM_FONT_SIZE_38px"],
  },
  {
    type: "paragraph-left",
    text: "Header 2",
    displayText: "Header 2",
    tag: "h2",
    styles: ["BOLD", "CUSTOM_FONT_SIZE_28px"],
  },
  {
    type: "paragraph-left",
    text: "Header 3",
    displayText: "Header 3",
    tag: "h3",
    styles: ["BOLD", "CUSTOM_FONT_SIZE_20px"],
  },
  {
    type: "paragraph-left",
    text: "Header 4",
    displayText: "Header 4",
    tag: "h4",
    styles: ["BOLD", "CUSTOM_FONT_SIZE_14px"],
  },
  {
    type: "paragraph-left",
    tag: "p",
    displayText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit...",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce ullamcorper porttitor neque, a semper urna tincidunt eu. Mauris suscipit risus lectus, non iaculis ligula fermentum sed. Vestibulum gravida a ligula nec aliquam. Sed a purus sapien. Aliquam congue ipsum sed blandit molestie. Nullam blandit dui lacus. Ut consequat ornare rhoncus. Morbi efficitur mi sit amet accumsan mollis. Aenean sagittis velit id magna tempus, nec sodales ex pharetra. Mauris at commodo sem. Nullam bibendum, ligula id tristique condimentum, diam purus ullamcorper erat, vel commodo enim sapien eget odio. Proin volutpat libero lectus, nec pellentesque diam bibendum id. Morbi eleifend eu justo quis viverra. Nunc scelerisque magna ut rhoncus aliquet. Donec blandit justo at leo mollis, nec dictum neque pulvinar.",
    styles: [],
  },
];
